<!-- 广告管理页面 -->
<template>
  <div>广告管理页面</div>
</template>

<script>
export default {
  data () {
    return {
    };
  },
  methods: {}
}

</script>
<style lang='scss' scoped>
</style>